<msf-list-page-wrapper [leftSize]="flexRowSizes.left" [rightSize]="flexRowSizes.right">
  <div
    left
    class="anomalies-content-panel"
    [ngClass]="{'anomalies-content-panel--map-view': viewTab === 'map'}">

    <div class="page-header">
      <app-back-button
        [title]="'ANOMALIES_MAP_PAGE_TITLE' | translate"
        [ngStyle]="{ 'font-size': isSmallScreen ? '14px' : 'inherit' }"
        parentRoute="/crop-monitoring"
      ></app-back-button>
      <div class="header-actions">
        <app-export-button
          (export)="exportMenu.toggle($event)"
          [loading]="exportLoading"
          [disabled]="exportLoading"
        ></app-export-button>
        <p-menu
          #exportMenu
          [model]="exportMenuItems"
          [popup]="true"
          appendTo="body"
        ></p-menu>
        <p-button
          *ngIf="isSmallScreen"
          icon="pi pi-filter"
          (click)="openFilterModal()"
          styleClass="filter-btn"
        ></p-button>
      </div>
    </div>

    <div class="requests-view-tabs-row">
      <div class="requests-view-tabs" role="tablist">
        <button
          type="button"
          class="requests-view-tab"
          [class.requests-view-tab--active]="viewTab === 'board'"
          (click)="viewTab = 'board'"
          role="tab"
          [attr.aria-selected]="viewTab === 'board'"
        >
          <i class="pi pi-list" aria-hidden="true"></i>
          <span>{{ 'GIS_BIDS_TAB_BOARD' | translate }}</span>
        </button>
        <button
          type="button"
          class="requests-view-tab"
          [class.requests-view-tab--active]="viewTab === 'map'"
          (click)="viewTab = 'map'"
          role="tab"
          [attr.aria-selected]="viewTab === 'map'"
        >
          <i class="pi pi-map" aria-hidden="true"></i>
          <span>{{ 'GIS_BIDS_TAB_MAP' | translate }}</span>
        </button>
      </div>
    </div>

    @if (viewTab === 'board') {
      <div class="anomalies-table-wrap" [class.anomalies-table-wrap--loading]="loading">
        <app-anomalies-list
          [compactLayout]="true"
          [allowDelete]="true"
          [appliedFilters]="filtersParams"
          (onZoomToPoint)="onListZoomToMap($event)"
        ></app-anomalies-list>
      </div>
    }

    @if (viewTab === 'map') {
      <div class="anomalies-map-panel">
        <app-gis-anomalies [filtersParams]="filtersParams"></app-gis-anomalies>
      </div>
    }
  </div>

  <div right *ngIf="!isSmallScreen">
    <msf-filters
      [fields]="anomalyFilterFields"
      [(ngModel)]="filters"
      (modelChange)="onFiltersModelChange($event)"
      (applyFilter)="applyFilters()"
      (clearFilter)="clearFilters()"
      [isLoading]="loading"
    />
  </div>
</msf-list-page-wrapper>

<p-dialog [resizable]="false" [draggable]="false"
  [(visible)]="isFilterModalOpen"
  [modal]="true"
  [closable]="true"
  [header]="'Filters' | translate"
>
  <msf-filters
    [fields]="anomalyFilterFields"
    [(ngModel)]="filters"
    (modelChange)="onFiltersModelChange($event)"
    [isLoading]="loading"
    (applyFilter)="applyFilters(); isFilterModalOpen = false"
    (clearFilter)="clearFilters(); isFilterModalOpen = false"
  />
</p-dialog>
